import {get} from './http';

export type VideoStatus = {
  id: string;
  title: string | null;
  description: string | null;
  channel_id: string | null;
  channel_title: string | null;
  thumbnail_url: string | null;
  published_at: string | null;
  privacy_status: string | null;
  embeddable: boolean | null;
  made_for_kids: boolean | null;
  self_declared_made_for_kids: boolean | null;
  is_channel_monetization_enabled: boolean | null;
  view_count: number | null;
  like_count: number | null;
  comment_count: number | null;
  duration: string | null;
  region_restriction_blocked: string[] | null;
  // The allow-list sibling of region_restriction_blocked: when non-empty the video is playable
  // *only* in these regions, which YouTube returns instead of a blocked list, never alongside one.
  region_restriction_allowed: string[] | null;
  default_language: string | null;
  default_audio_language: string | null;
  channel_country: string | null;
  // The owning channel's public statistics, from the same channels.list call the API already makes
  // for monetization - no extra quota. Absent for a video whose channel could not be fetched.
  channel_subscriber_count: number | null;
  channel_hidden_subscriber_count: boolean | null;
  channel_video_count: number | null;
  channel_custom_url: string | null;
  // Comma-separated - matches Scrapy's own convention for this field.
  tags: string | null;
  // Resolved server-side from the numeric category id; null when unrecognised.
  category_name: string | null;
  age_restricted: boolean | null;
  // "live", "upcoming" or "none".
  live_broadcast_content: string | null;
  // Covers a finished stream's recording too, which reports live_broadcast_content "none".
  is_livestream: boolean | null;
  live_actual_start_time: string | null;
  live_actual_end_time: string | null;
  has_captions: boolean | null;
  // "hd" or "sd".
  definition: string | null;
  // "youtube" or "creativeCommon".
  license: string | null;
  // Undocumented upstream - absent from the platform's own reference, so it can vanish without
  // notice. Treat null as unknown rather than "not a short".
  is_short: boolean | null;
  // The platform's own "safe for minors" signal (contentDetails.inBucket). Undocumented upstream for
  // the same reason as is_short above, so null means unknown, not "not safe for minors".
  safe_for_minors: boolean | null;
  topic_categories: string[] | null;
  // The largest size available, for close inspection in the lightbox. thumbnail_url stays the modest
  // size the grid tiles and the persisted item use.
  thumbnail_url_high: string | null;
};

export type VideoStatusListResponse = {
  results: VideoStatus[];
};

export const videosApi = {
  status: async (videoId: string) =>
    get<VideoStatus>(`/videos/${encodeURIComponent(videoId)}/status`),

  statuses: async (videoIds: string[]) =>
    get<VideoStatusListResponse>('/videos/status', {ids: videoIds.join(',')})
};
